var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeltaLake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 44.848c4.146-7.643 11.704-11.168 18.755-9.617 2.34.507 4.54 1.692 6.797 2.566 2.256.874 4.484 2.002 6.825 2.538 1.663.395 3.525.113 5.273-.113 1.608-.197 1.805-.817.987-2.227-1.72-2.962-3.468-5.923-5.189-8.884l-7.953-13.622c-.874-1.495-1.128-1.466-2.002.028l-6.346 10.83c-.197.338-.338.733-.48 1.015 2.172.96 4.26 1.749 6.262 2.764 1.156.592 2.171 1.467 3.187 2.313.45.366.648 1.015.987 1.523-.593-.057-1.213 0-1.805-.141-2.313-.536-4.597-1.382-6.938-1.636-4.174-.451-8.207.677-12.127 2.002-.423.141-.93.028-1.41.028.113-.423.113-.902.31-1.269 5.894-10.265 11.902-20.53 17.909-30.768.93-1.608 1.946-1.551 2.876.056 7.05 12.043 14.073 24.057 21.124 36.099 1.55 2.68 1.297 4.315-1.354 5.922-6.007 3.695-12.24 4.174-18.614.931-1.55-.79-3.158-1.438-4.71-2.256-4.963-2.623-10.096-2.623-15.285-.874-1.918.62-3.75 1.494-5.612 2.228-.367.14-.733.282-1.467.564z",
    fill: "#0078D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeltaLake);
export default __webpack_public_path__ + "static/media/DeltaLake.ed6e39e92662f15f8ebfffbf2ad081f9.svg";
export { ForwardRef as ReactComponent };